import { Component, OnInit, ViewChildren, QueryList, ElementRef, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DocumentManagementService } from 'src/framework/services/manage-doc.service';
import { LabelcardMgmtService } from 'src/framework/services/labelcard-mgmt.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { FolderManagementService } from 'src/framework/services/folder-mgmt.service';
import { MessageService, TreeNode } from 'primeng';
import { DocverHistoryService } from 'src/framework/services/docver-history.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal'
import { UserService } from 'src/framework/services/userservice';
import { ModalContentComponent } from 'src/app/shared/modal-component/modal.component';
import { TopicCardService } from 'src/framework/services/topic-card.service';
import * as _ from 'lodash';
import { AddNewTopicCardComponent } from '../add-new-topic-card/add-new-topic-card.component';
import { EditTopicCardComponent } from '../edit-topic-card/edit-topic-card.component';
import { Cards } from 'src/app/entities/topic-card';
import { LanguageService } from 'src/framework/services/language.service';
import { CategoryConstant } from 'src/app/shared/app-constants/category-constants';

@Component({
  selector: 'app-topic-card',
  templateUrl: './topic-card.component.html',
  styleUrls: ['./topic-card.component.css']
})
export class TopicCardComponent implements OnInit {
  @Input() selectedtopicCard=0;

  @ViewChildren('uploadNewDocComponent') uploadNewDoc: QueryList<AddNewTopicCardComponent>;
  @ViewChildren('editDocComponent') editDoc: QueryList<EditTopicCardComponent>;
  @ViewChildren('ctrlAddTab') ctrlAddTab: QueryList<ElementRef>;
  @ViewChildren('ctrlEditTab') ctrlEditTab: QueryList<ElementRef>;


  selectedNode: TreeNode;
  targetTreeData: any[]=[];
  showSideBar = false;
  showFileVersionGrid = false;
  docVersionList: any[] = [];
  gridVersionList: any[] = [];
  engagementDocList: any[] = [];
  processedDocIdList: any[] = [];
  cols: any[];
  cities=[];
  selectedCity1:any;
  colmns: any[];
  editDocVersionList: any[] = [];
  addTabIndex = 0;
  editTabIndex = 0;
  appLangList: any[] = [];
  docStatusList: any[] = [];
  docTypeList: any[] = [];
  maxSeed: number = 0;
  documentVersionHistoryModel: any[]
  showHistory = false;
  isApproveDisabled = false;
  public selectedColumns: any[];
  public columnOptions: any[];
  exportColumns: any[];
  bsModalRef: BsModalRef;
  showDocVersionCategoryId:number;

  selectedAppLanguage: any;
  selectedAppLanguageJson: any;
  defaultEnglishJson: any;
  selectedLangDocTypeJson: any;
  defaultEngDocTypeJson: any;
  selectedLangStatusJson: any;
  defaultEngStatusJson: any;
  selectedLangLabelJson: any;
  defaultEngLangLabelJson: any;
  islabelLoaded: boolean = false;
  selectedLangDateJson: any;
  defaultEngDateJson: any;

  engagementDetail = {
    appLanguage: 1,
    engagementId: 1,
    engagementName: '',
    engStatusId: 1,
    engStatusName: '',
    engInitialDate: null,
    engLanguage: [{
      "languageId": 1,
      "languageName": "English",
      "languageFlagPath": "../../assets/flags/English.png"
    }],
    engLanguageFrench: [{
      "languageId": 1,
      "languageName": "Anglaise",
      "languageFlagPath": "../../assets/flags/English.png"
    }]
  }
  showDocVersionTypeId: number;
  isUnapproved: boolean = true;
  showEditSideBar: boolean;
  saveMsg: string;
  topics=[];
  userDetail: any = {};
  isAllNonApproved: boolean = false;
  canApproveOtherLang: boolean = false;
  selectedFilePath: string;
  userList: any[] = [];
  uploadFileKey: any = null;
 cards= new Cards();
  docCategoryList: any[] = [];
  fileName="";
  selectedGlobalLanguageJson: any;
  defaultGlobalEnglishJson:any



  constructor(private http: HttpClient, private manageDocService: TopicCardService,
    private labelCardService: LabelcardMgmtService, private spinner: NgxSpinnerService,
    private datePipe: DatePipe, private folderService: FolderManagementService,
    private messageService: MessageService, private DocService: DocverHistoryService,
    private modalService: BsModalService,private userService : UserService,private languageService:LanguageService
  ) {


    

  }

  ngOnInit(): void {
    this.loadLanguageLabel();
    this.fileName="topicCardVersionHistoryLogs_export_" + new Date().getTime();
    if (sessionStorage.getItem('userDetail')) {
      this.userDetail = JSON.parse(sessionStorage.getItem('userDetail'));
    }

    this.cards.topicCard["primary"]=[];
      this.cards.topicCard["secondary"]=[];
      this.cards.statusUpdate=[];

    this.loadMasterData()
      .then(res => (
        this.initializeEngagementData()
          .then(res => res=> this.getTopicCards())
      ));
  }


  loadLanguageLabel() {
    let englishLanguageMappings, selectedLanguageMappings: any;
    let englishDocTypeMappings, selectedLangDocTypeMappings: any;
    let englishStatusMappings, selectedLangStatusMappings: any;
    let englishLangLabelMappings, selectedLangLabelMappings: any;
    let englishglobalLanguageMappings, selectedglobalLanguageMappings: any;
    let englishDateMappings, selectedLangDateMappings: any;

    return new Promise((resolve, reject) => {
      if (sessionStorage.getItem('selectedLanguageId')) {
        this.selectedAppLanguage = 1;//JSON.parse(sessionStorage.getItem('selectedLanguageId'));
      }

      this.languageService.currentData.subscribe(data => {
        this.spinner.show();
        this.selectedAppLanguage = data.Id
        this.engagementDetail.appLanguage = this.selectedAppLanguage;
      });


      this.languageService.mySubject.subscribe((data) => {
        var languageMappings = data;
        if (languageMappings?.length > 0) {

          englishLanguageMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.TopicCards.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishDocTypeMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.DocumentTypes.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishStatusMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Status.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishLangLabelMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Language.toLowerCase()
            && Number(item?.languageId) === 1)[0];

            englishglobalLanguageMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Global.toLowerCase()
              && Number(item?.languageId) === 1)[0];

            englishDateMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Calendar.toLowerCase()
              && Number(item?.languageId) === 1)[0];
  

          if (englishLanguageMappings?.isGlobal) {
            selectedLanguageMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.TopicCards.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

            selectedLangDocTypeMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.DocumentTypes.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

            selectedLangStatusMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Status.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

            selectedLangLabelMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Language.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

              selectedglobalLanguageMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Global.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];   

              selectedLangDateMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Calendar.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

          }
          else {
            if (Number(this.selectedAppLanguage) === 2) {
              selectedLanguageMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.TopicCards.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

              selectedLangDocTypeMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.DocumentTypes.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

              selectedLangStatusMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Status.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

              selectedLangLabelMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Language.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

                selectedglobalLanguageMappings = languageMappings.filter(item =>
                  item?.categoryName?.toLowerCase() === CategoryConstant.Global.toLowerCase()
                  && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];
              

                selectedLangDateMappings = languageMappings.filter(item =>
                  item?.categoryName?.toLowerCase() === CategoryConstant.Calendar.toLowerCase()
                  && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];
            }
            else {
              selectedLanguageMappings = englishLanguageMappings;
              selectedLangDocTypeMappings = englishDocTypeMappings;
              selectedLangStatusMappings = englishStatusMappings;
              selectedLangLabelMappings = englishLangLabelMappings;
              selectedglobalLanguageMappings = englishglobalLanguageMappings;
              selectedLangDateMappings = englishDateMappings;

            }
          }

          this.selectedAppLanguageJson = JSON.parse(selectedLanguageMappings?.languageMappingJSON ?? englishLanguageMappings.languageMappingJSON);
          this.defaultEnglishJson = JSON.parse(englishLanguageMappings.languageMappingJSON);

          this.selectedLangDocTypeJson = JSON.parse(selectedLangDocTypeMappings?.languageMappingJSON ?? englishDocTypeMappings.languageMappingJSON);
          this.defaultEngDocTypeJson = JSON.parse(englishDocTypeMappings.languageMappingJSON);

          this.selectedLangStatusJson = JSON.parse(selectedLangStatusMappings?.languageMappingJSON ?? englishStatusMappings.languageMappingJSON);
          this.defaultEngStatusJson = JSON.parse(englishStatusMappings.languageMappingJSON);

          this.selectedLangLabelJson = JSON.parse(selectedLangLabelMappings?.languageMappingJSON ?? englishLangLabelMappings.languageMappingJSON);
          this.defaultEngLangLabelJson = JSON.parse(englishLangLabelMappings.languageMappingJSON);

          this.selectedGlobalLanguageJson = JSON.parse(selectedglobalLanguageMappings.languageMappingJSON);
          this.defaultGlobalEnglishJson = JSON.parse(englishglobalLanguageMappings.languageMappingJSON);

          this.selectedLangDateJson = JSON.parse(selectedLangDateMappings?.languageMappingJSON ?? englishDateMappings.languageMappingJSON);
          this.defaultEngDateJson = JSON.parse(englishDateMappings.languageMappingJSON);

          this.islabelLoaded =false; 
              this.cols = [
                { field: 'statusName', header: this.labelReplacer('Status') },
                { field: 'languageName', header: this.labelReplacer('Language') },
                { field: 'topicCardCategory', header: this.labelReplacer('Category') },
                { field: 'tctitle', header: this.labelReplacer('Title') },
                { field: 'description', header: this.labelReplacer('Description') },
                { field: 'topicCardType', header: this.labelReplacer('Type') },
                { field: 'topicCardDateStr', header: this.labelReplacer('Date') }    ];
              this.colmns = [
                { field: 'topicCardId', header: this.labelReplacer('TopicCardID') },
                { field: 'tcversionId', header: this.labelReplacer('TopicCardVersionID') },
                { field: 'languageName', header: this.labelReplacer('Language') },
                { field: 'statusName', header: this.labelReplacer('Status') },
                { field: 'currentAuthorized', header: this.labelReplacer('CurrentAuthorized') },
                { field: 'currentDraft', header: this.labelReplacer('CurrentDraft') },
                { field: 'tctitle', header: this.labelReplacer('TopicCardTitle') },
                { field: 'description', header: this.labelReplacer('TopicCardDescription') },
                { field: 'createdBy', header: this.labelReplacer('CreatedBy') },
                { field: 'createdDate', header: this.labelReplacer('CreatedDate') },
                { field: 'approvalRequestedByGpn', header: this.labelReplacer('ApprovalRequestedByGPN') },
                { field: 'approvalRequestedFromGpn', header: this.labelReplacer('ApprovalRequestedFromGPN') },
                { field: 'approvalRequestedStringFormat', header: this.labelReplacer('ApprovalRequestedDateTime') },
                { field: 'authorizedByGpn', header: this.labelReplacer('AuthorizedByGPN') },
                { field: 'authorizedStringFormat', header: this.labelReplacer('AuthorizedDateTime') },
                { field: 'postedDateStringFormat', header: this.labelReplacer('PostedDate') },
                { field: 'authorizationEndedByGpn', header: this.labelReplacer('AuthorizationEndedByGPN') },
                { field: 'authorizationEndStringFormat', header: this.labelReplacer('AuthorizationEndedDateTime') },
                { field: 'logCreatedDate', header: this.labelReplacer('LogCreatedDate') },
                { field: 'logCreatedBy', header: this.labelReplacer('LogCreatedBy') }
              ];
              this.exportColumns = this.colmns.map(col => ({ title: col.header, dataKey: col.field }));

    this.columnOptions = [];
    this.selectedColumns = [];
    for (let i = 0; i < this.colmns.length; i++) {
      this.columnOptions.push({ label: this.colmns[i].header, value: this.colmns[i] });
    }

    this.formatVersionList()

    this.islabelLoaded = true;
          resolve(1);
        }
        else {

        }
      });
    })
      .catch(err => {
        console.log(err);
      });
  }


  labelReplacer(labelKey): string {
    return this.selectedAppLanguageJson[labelKey]?.trim() ? this.selectedAppLanguageJson[labelKey] ?? 'text not found' : this.defaultEnglishJson[labelKey] ?? 'text not found';
  }

  docTypeReplacer(labelKey): string {
    return this.selectedLangDocTypeJson[labelKey]?.trim() ? this.selectedLangDocTypeJson[labelKey] ?? 'text not found' : this.defaultEngDocTypeJson[labelKey] ?? 'text not found';
  }

  activeReplacer(labelKey): string {
    return  this.selectedGlobalLanguageJson[labelKey]?.trim() ? this.selectedGlobalLanguageJson[labelKey] ?? 'text not found' : this.defaultGlobalEnglishJson[labelKey] ?? 'text not found';
  }

  statusReplacer(labelKey): string {
    return this.selectedLangStatusJson[labelKey]?.trim() ? this.selectedLangStatusJson[labelKey] ?? 'text not found' : this.defaultEngStatusJson[labelKey] ?? 'text not found';
  }

  languageReplacer(labelKey): string {
    return this.selectedLangLabelJson[labelKey]?.trim() ? this.selectedLangLabelJson[labelKey] ?? 'text not found' : this.defaultEngLangLabelJson[labelKey] ?? 'text not found';
  }

  monthReplacer(labelKey): string {
    let localeDt;
    if (labelKey) {
      let arr = labelKey.split(' ');
      if (arr?.length == 3)
        localeDt = arr[0] + ' ' + this.calendarReplacer(arr[1]?.toUpperCase()) + ' ' + arr[2];
      else if (arr?.length == 4)
        localeDt = arr[0] + ' ' + this.calendarReplacer(arr[1]?.toUpperCase()) + ' ' + arr[2] + ' ' + arr[3];
      else
        localeDt = labelKey;
    }
    return localeDt;
  }

  calendarReplacer(labelKey): string {
    return this.selectedLangDateJson[labelKey]?.trim() ? this.selectedLangDateJson[labelKey] ?? 'text not found' : this.defaultEngDateJson[labelKey] ?? 'text not found';
  }

  dayOrMonthNameShort(name, length): string {
    let shortName = '';
    if (name?.trim()?.length == 0)
      shortName = 'Text not found';
    else if (name?.trim()?.length > 0 && name?.trim()?.length < length)
      shortName = name;
    else
      shortName = name.substr(0, length);
    return shortName;
  }

  initializeEngagementData() {
    this.spinner.show();
    return new Promise((resolve, reject) => {
      if (sessionStorage.getItem('appLanguageList')) {
        this.appLangList = JSON.parse(sessionStorage.getItem('appLanguageList'));
      }
      else {
        this.getLanguageList();
      }
      if (sessionStorage.getItem('engagementDetail')) {
        this.engagementDetail = JSON.parse(sessionStorage.getItem('engagementDetail'));

      }
      resolve(1);
    });
  }


  getTopicCards() {

    this.cards.topicCard["primary"]=[];
    this.cards.topicCard["secondary"]=[];
    this.cards.statusUpdate=[];
    this.cities=[];
    this.targetTreeData=[];
    this.engagementDetail["selectedLanguageId"]=this.selectedAppLanguage;
    this.manageDocService.getEngagementTopicCardsBasedOnLanguage(this.engagementDetail).subscribe(files => {
      this.targetTreeData =files.data;
      this.engagementDocList = files.data;
      this.preProcessTree();
      this.targetTreeData.forEach(items=>{
        items.topicCardVersionList=items.topicCardVersionList.filter(e=>e.styleClass != 'fileClass hideFileClass');
      });
      
      this.targetTreeData.forEach(item=>{
        if(item.topicCardTypeId==1){
          if(item.topicCardCategoryId==1){
            this.cards.topicCard["primary"].push(item.topicCardVersionList[0]);
          }
          else{
            this.cards.topicCard["secondary"].push(item.topicCardVersionList[0]);
          }
        }
        else if(item.topicCardTypeId==2){
            this.cards.statusUpdate.push(item.topicCardVersionList[0]);
        }
        this.cities.push(item.topicCardVersionList[0]);
      });
      this.cards.topicCard["primary"]  = this.cards.topicCard["primary"].sort((a, b) =>{

        a.topicCardDate = a.topicCardDate.split('/').reverse().join('');
        b.topicCardDate = b.topicCardDate.split('/').reverse().join('');
        return a.topicCardDate < b.topicCardDate ? 1 : a.topicCardDate > b.topicCardDate ? -1 : 0;
      });
      this.cards.topicCard["secondary"] =  this.cards.topicCard["secondary"].sort((a, b) =>{

        a.topicCardDate = a.topicCardDate.split('/').reverse().join('');
        b.topicCardDate = b.topicCardDate.split('/').reverse().join('');
        return a.topicCardDate < b.topicCardDate ? 1 : a.topicCardDate > b.topicCardDate ? -1 : 0;
      });

      this.cards.statusUpdate =  this.cards.statusUpdate.sort((a, b) =>{

        a.topicCardDate = a.topicCardDate.split('/').reverse().join('');
        b.topicCardDate = b.topicCardDate.split('/').reverse().join('');
        return a.topicCardDate < b.topicCardDate ? 1 : a.topicCardDate > b.topicCardDate ? -1 : 0;
      });


      if(this.selectedtopicCard!=0 && this.selectedtopicCard!=undefined){
        this.topics=this.targetTreeData.filter(item=>item.topicCardId==this.selectedtopicCard)
        if(this.topics.length>0){
        this.viewFileVersion(this.topics[0]);
        }
      }
      this.spinner.hide();
    });

  }

  preProcessTree() {
    this.processedDocIdList = [];

    return new Promise((resolve, reject) => {
      this.targetTreeData.forEach(x => {
        this.toggleFileDisplay(x);
      });
      resolve(1);
    });

  }



  displayFolderLabel(node: TreeNode): string {
    let primaryLangId, otherPrimaryLangId = 0;
    let nodeLangList: any[] = [];
    let langIndex = -1;
    let folderLabel = '';

    if (this.engagementDetail.appLanguage == 2) {
      primaryLangId = 2;
      otherPrimaryLangId = 1;
    }
    else //default is english
    {
      primaryLangId = 1;
      otherPrimaryLangId = 2;
    }

    folderLabel = node.label;
    nodeLangList = node?.data[0]?.language;

    if (nodeLangList.length > 0) {
      if ((langIndex = nodeLangList.findIndex(x => Number(x.languageId) === Number(primaryLangId))) > -1) {
        if (nodeLangList[langIndex]?.folderName?.trim() !== '') {
          folderLabel = nodeLangList[langIndex]?.folderName;
        }
        else {
          if ((langIndex = nodeLangList.findIndex(x => Number(x.languageId) === Number(otherPrimaryLangId))) > -1) {
            if (nodeLangList[langIndex]?.folderName?.trim() !== '') {
              folderLabel = nodeLangList[langIndex]?.folderName;
            }
          }
        }
      }
    }


    return folderLabel;

  }

  // Start function



  toggleFileDisplay(node: any) {
    let primaryLangId, otherPrimaryLangId = 0;
    let currentDocId = 0;
    let treeVersionList: any[] = [];
    let detailVersionList: any[] = [];
    let matchFound = false;

    if (this.engagementDetail.appLanguage == 2) {
      primaryLangId = 2;
      otherPrimaryLangId = 1;
    }
    else //default is english
    {
      primaryLangId = 1;
      otherPrimaryLangId = 2;
    }

    if (!this.processedDocIdList?.includes(node?.topicCardId)) {
      currentDocId = node?.topicCardId;
      this.processedDocIdList.push(currentDocId);

      //fetch all versions for current docid from tree
      treeVersionList = this.targetTreeData?.filter(x => Number(x.topicCardId) === Number(currentDocId))[0]?.topicCardVersionList;
      detailVersionList = this.engagementDocList?.filter(x => Number(x.topicCardId) === Number(currentDocId))[0]?.topicCardVersionList;

      if (treeVersionList && detailVersionList) {

        if (treeVersionList?.length === detailVersionList?.length) {

          matchFound = this.isDisplayVersionInSelectedLang(treeVersionList, detailVersionList, primaryLangId);

          if (!matchFound) {
            this.isDisplayVersionInSelectedLang(treeVersionList, detailVersionList, otherPrimaryLangId);
          }
        }
      }
    }

  }

  isDisplayVersionInSelectedLang(treeVersionList: any[], detailVersionList: any[], primaryLangId): boolean {
    let unAuthList: any[] = [];
    let authIndex, draftIndex, unAuthIndex = -1;
    let fileStyle = [];
    const isAnyAuthorized = (x) => (x.currentAuthorized && !x.currentDraft);
    const isAnyDraft = (x) => (!x.currentAuthorized && x.currentDraft
      && x.approvalRequestedByGpn === null && x.approvalRequestedFromGpn === null);
    const isAnyAuthPending = (x) => (!x.currentAuthorized && x.currentDraft
      && x.approvalRequestedByGpn != null && x.approvalRequestedFromGpn != null
      && x.authorizedByGpn === null && x.authorizedDateTime === null);

    if (!detailVersionList.some(isAnyAuthorized)) {
      fileStyle.push('G');
      if (detailVersionList.some(isAnyAuthPending)) {
        fileStyle.push('A');
      }
    }
    else if (detailVersionList.some(isAnyAuthPending)) {
      fileStyle.push('A');
    }
    else if (detailVersionList.some(isAnyDraft)) {
      fileStyle.push('D');
    }


    //check for current authorized version in selected language
    authIndex = detailVersionList?.findIndex(x => x.currentAuthorized
      && !x.currentDraft && Number(x.languageId) === Number(primaryLangId));
    //check for current draft version in selected language
    draftIndex = detailVersionList?.findIndex(x => !x.currentAuthorized
      && x.currentDraft && Number(x.languageId) === Number(primaryLangId));
    //check for unauthorized versions in selected language
    unAuthList = detailVersionList?.filter(x => !x.currentAuthorized
      && !x.currentDraft && Number(x.languageId) === Number(primaryLangId))?.sort(this.date_sort_desc);
    if (authIndex > -1) {
      this.setFileToggleClass(treeVersionList, detailVersionList, authIndex, fileStyle);
    }
    else if (draftIndex > -1) {
      this.setFileToggleClass(treeVersionList, detailVersionList, draftIndex, fileStyle);
    }
    else {
      if (unAuthList.length > 0) {
        unAuthIndex = detailVersionList.indexOf(unAuthList[0]);
        this.setFileToggleClass(treeVersionList, detailVersionList, unAuthIndex, fileStyle);

      }
    }

    if (authIndex === -1 && draftIndex === -1 && unAuthIndex === -1) {
      return false;
    }
    return true;

  }

  setFileToggleClass(treeVersionList, detailVersionList, versionIndex, fileStyle) {
    treeVersionList.forEach(x => {
      if (Number(x?.tcversionId) === Number(detailVersionList[versionIndex]?.tcversionId)) {
        x['styleClass'] = 'fileClass';
        x.showDraftMark = false;
        x.showRedMark = false;

        //Add additonal styles to visible file
        if (fileStyle.length > 0) {
          fileStyle.forEach(style => {
            if (style === 'G') {
              x['styleClass'] = 'fileClass grayFileClass';
            }
            if (style === 'D') {
              x.showDraftMark = true;
            }
            if (style === 'A') {
              x.showRedMark = true;
            }
          });
        }

      }
      else {
        x['styleClass'] = 'fileClass hideFileClass';
      }
    });
  }

  get globalIdentitySeed() {

    if (this.targetTreeData.length > 0) {

      this.targetTreeData.forEach(node => {
        this.getMaxSeedValue(node);
      });
    }

    return this.maxSeed;
  }

  set globalIdentitySeed(value) {
    this.maxSeed = value;
  }

  getMaxSeedValue(node: TreeNode) {

    if (this.maxSeed < Number(node.key)) {
      this.maxSeed = Number(node.key);
    }
    if (node.children) {
      node.children.forEach(childNode => {
        this.getMaxSeedValue(childNode);
      });
    }

  }

  getStatusPillClass(statusId: Number) {

    let pillClass = '';
    if (statusId) {
      if (statusId === 2 || statusId === 4 || statusId === 7)
        pillClass = 'pill pill--approved m-0';
      else if (statusId === 1)
        pillClass = 'pill pill--closed m-0';
      else if (statusId === 3 || statusId === 6)
        pillClass = 'pill pill--failed m-0';
      // else if (statusId === 'authorized')
      //   pillClass = 'pill pill--hold m-0';
    }

    return pillClass;
  }

  loadMasterData() {
    return new Promise((resolve, reject) => {
      this.getTopicCardType()
        .then(res => 
          this.getTopicCardCategories()
          .then(res=>
          this.getDocStatus()
          .then(res => 
            this.getUserList()
            .then(res => 
              resolve(1))
          )))
        .catch(error => console.log(error))
    });

  }
    
    getTopicCardCategories() {
      return new Promise((resolve, reject) => {
    this.manageDocService.getTopicCardCategory().subscribe(res => {
      if (res) {
        //success
        this.docCategoryList = res.data;
        this.docCategoryList.forEach(item=>{
          item.topicCardCategoryDescription=this.activeReplacer(item.topicCardCategoryDescription);
        })
      } else {
        //display error
      }
      resolve(1);
    });
  });
}


  

  getUserList(){
    return new Promise((resolve, reject) => {
      this.userService.GetUserList().subscribe(res => {
        if (res.status === 0) {
          //success
          this.userList = res.data;
        } else {
          //display error
        }
        resolve(1);
      });
    });
  }
  getDocStatus() {

    return new Promise((resolve, reject) => {
      this.manageDocService.getDocStatus().subscribe(res => {
        if (res) {
          //success
          this.docStatusList = res.data;
        } else {
          //display error
        }
        resolve(1);
      });
    });
  }



 

  toggleBack() {
    this.showHistory = false;
  }

  getLanguageList() {
    return new Promise((resolve, reject) => {
      this.labelCardService.getLanguageList().subscribe(res => {
        if (res) {
          //success
          // this.appLangList = res;
          res.forEach(element => {
            if (element.isAppLanguage) {
              this.appLangList.push({
                languageId: element.languageId,
                languageName: element.name,
                languageFlagPath: element.languagePath
              });
            }

          });
        } else {
          //display error
        }
        resolve(1);
      });
    });
  }

  sortTree() {
    this.targetTreeData.sort((a, b) => a.label?.localeCompare(b.label));
    this.targetTreeData.forEach(element => {
      element.children?.sort((a, b) => a.label?.localeCompare(b.label));
    });


  }

  getFiles() {
    return this.http.get<any>('../../../../assets/files/treedata.js')
      .toPromise()
      .then(res => <TreeNode[]>res.data);
  }

  nodeSelect(event) {
    let selectedNodeCopy: TreeNode = {};
    this.showHistory = false;

    this.selectedNode = event?.node;

    if (event?.node?.type === 'file') {

      selectedNodeCopy = _.cloneDeep(this.selectedNode);
      this.setAbsoluteFilePath(selectedNodeCopy);
      this.viewFileVersion(event.node);
    }
    else {
      this.showFileVersionGrid = false;
    }
  }

  setAbsoluteFilePath(node: TreeNode) {
    let filePath = '';
    this.selectedFilePath = '';
    node = node.parent;
    while (node?.parent !== undefined && node?.parent !== null) {
      filePath = node.label + '/' + filePath;
      node = node.parent;
    }

    this.selectedFilePath = filePath;
  }

  nodeDrop(event) {

    let sourceNode: TreeNode = event.dragNode?.parent;
    let dragNode: TreeNode = event.dragNode;
    let targetNode: TreeNode;
    let versionNodeList: TreeNode[];
    let isReshuffle = false;
    let versionIndex = -1;

    if ('index' in event) {
      targetNode = event?.dropNode;
    }
    else if (event?.hasOwnProperty('dropIndex')) {
      targetNode = event?.dropNode?.parent;
    }

    //check for re-position in same folder
    if (sourceNode.key === targetNode.key) {
      isReshuffle = true;
    }

    if (!isReshuffle) {
      dragNode.data[0].parentId = targetNode.key;
      //fetch other versions of the same docid
      versionNodeList = sourceNode?.children.filter(x => x?.type.toLowerCase() === 'file'
        && (+x?.data[0]?.docId === +sourceNode?.data[0]?.docId));

      if (versionNodeList.length > 0) {
        versionNodeList.forEach(versionNode => {
          if (+versionNode.key !== +dragNode.key) {
            versionIndex = sourceNode?.children.indexOf(versionNode);
            if (versionIndex > -1) {
              sourceNode?.children.splice(versionIndex, 1);
              versionNode.data[0].parentId = targetNode.key;
              if (targetNode.children.indexOf(versionNode) === -1) {
                targetNode.children.push(versionNode);
              }
            }
          }
        });

      }
    }
    event.dropNode.expanded = true;
  }


  expandAll() {
    this.targetTreeData.forEach(node => {
      this.expandRecursive(node, true);
    });
  }

  collapseAll() {
    this.targetTreeData.forEach(node => {
      this.expandRecursive(node, false);
    });
    if(this.targetTreeData.length>0){
    this.targetTreeData[0].expanded = true;
    }
  }

  expandRecursive(node: TreeNode, isExpand: boolean) {
    node.expanded = isExpand;
    if (node.children) {
      node.children.forEach(childNode => {
        this.expandRecursive(childNode, isExpand);
      });
    }
  }

  getFileIcon(node: TreeNode) {
    let fileType = node.data[0]?.fileType?.toLowerCase();

    //attach file icon based on file type
    if (fileType === '.pdf') {
      node.data[0].fileTypeIcon = 'picture_as_pdf';
      node.data[0].fileIconStyle = '#E0362C';
    }
    else if (fileType === '.doc' || fileType === '.docx' || fileType === '.dot'
      || fileType === '.txt') {
      node.data[0].fileTypeIcon = 'description';
      node.data[0].fileIconStyle = '#1777CF';
    }
    else if (fileType === '.xls' || fileType === '.xlsx' || fileType === '.xlsb'
      || fileType === '.csv') {
      node.data[0].fileTypeIcon = 'insert_chart';
      node.data[0].fileIconStyle = '#189D3E';
    }
    else if (fileType === '.jpg' || fileType === '.jpeg' || fileType === '.png'
      || fileType === '.tif') {
      node.data[0].fileTypeIcon = 'insert_photo';
      node.data[0].fileIconStyle = '#FF6D00';
    }
    else {
      node.data[0].fileTypeIcon = 'help';
    }


  }

  getFileLabel(node: TreeNode) {
    let nodeLabel = '';
    let docDate = '';
    let fileSizeInMb = 0;
    if (node !== null && node != undefined) {
      nodeLabel += node.label + ' - ';
      if (node.data[0]?.documentDate !== null && node.data[0]?.documentDate !== undefined) {
        docDate = new Date(node.data[0]?.documentDate)?.toUTCString();
      }
      else {
        docDate = new Date(node.data[0]?.createdDTTM)?.toUTCString();
      }

      if (docDate !== 'Invalid Date')
        docDate = this.datePipe.transform(docDate, "dd MMM, yyyy");
      nodeLabel += docDate + ' - '

      fileSizeInMb = Math.round((node.data[0]?.fileSize / 1024));

      nodeLabel += fileSizeInMb + ' KB';


      return nodeLabel;
    }
  }
  uploadFile(node) {
    this.uploadFileKey = node?.key ?? null;
  }

  getSavedDoc(emitDocData) {

    this.spinner.show();
    this.showSideBar = false;


      //auto save tree with new file added
      this.getTopicCards();
      this.saveMsg = 'Topic Card saved successfully.';
     

    this.spinner.hide();

  }


  disableDelete(rowData) {
    let isDisabled = true;
    let otherPrimaryLang = 0;
    const isDraftInOpl = (x) => (Number(x.languageId) === Number(otherPrimaryLang) && Number(x.statusId) === 1);
    const isOtherLangDraftExist = (x) => (Number(x.languageId) !== 1 && Number(x.languageId) !== 2 && Number(x.statusId) === 1);

    if (Number(rowData['statusId']) === 1) {
      //allow delete if only one draft version exists for docid
      if (this.docVersionList.length == 1)
        isDisabled = false;
      else {
        if (Number(rowData['languageId']) === 1) { //english
          otherPrimaryLang = 2; //french
        }
        else if (Number(rowData['languageId']) === 2)//french
        {
          otherPrimaryLang = 1; //english
        }

        if (Number(rowData['languageId']) === 1 || Number(rowData['languageId']) === 2) {
          //check if OPL draft exists
          if (this.docVersionList.findIndex(isDraftInOpl) > -1) {
            isDisabled = false;
          }
          else {
            //check if draft exists in any other language
            if (this.docVersionList.some(isOtherLangDraftExist)) {
              isDisabled = true;
            }
            else {
              isDisabled = false;
            }
          }

        }
        else {
          isDisabled = false;
        }
      }

    }
    return isDisabled;
  }




  editDocVersion() {
    this.spinner.show();
    return new Promise((resolve, reject) => {

      this.showEditSideBar = true;
      this.editDocVersionList = [];
      this.computeDocPerLang()
        .then(res => this.spinner.hide())
        .catch((error) => {
          console.log(error);
          this.spinner.hide();
        });
      resolve(1);
    })
      .catch((error) => {
        console.log(error);
        this.spinner.hide();
      });
  }

  computeDocPerLang() {

    return new Promise((resolve, reject) => {

      let docByLangList: any[];
      let nonDraftIndex = -1;
      let draftIndex = -1;
      let editDocLangList: any[] = [];
      let showDraftButton: boolean = false;
      let showDraftIcon: boolean = false;
      let showPendingDraftIcon = false;
      this.canApproveOtherLang = false;


      const isAnyNonDraft = (x) => ((!x.currentAuthorized && !x.currentDraft)
        || (x.currentAuthorized && !x.currentDraft));
      const isApprovedInPrimaryLang = (x) => ((x.languageId === 1 || x.languageId === 2) && x.currentAuthorized && !x.currentDraft);

      this.canApproveOtherLang = this.gridVersionList.some(isApprovedInPrimaryLang);

      this.isAllNonApproved = this.gridVersionList.every(x => !x.currentAuthorized);
      if (this.gridVersionList.length > 0) {
        this.engagementDetail.engLanguage.forEach(engLang => {
          docByLangList = this.gridVersionList.filter(x => Number(x.languageId) === Number(engLang.languageId));

          if (docByLangList && docByLangList.length > 0) {
            //check for non draft doc if any to show on LHS for language tab
            if ((nonDraftIndex = docByLangList.findIndex(isAnyNonDraft)) > -1) {
              showDraftButton = true;
              editDocLangList.push(
                docByLangList[nonDraftIndex]
              );
            }

            //check for existing draft (if any)
            if ((draftIndex = docByLangList.findIndex(x => Number(x.statusId) === 1)) > -1) {
              showDraftButton = false;
              showDraftIcon = true;
              if (docByLangList[draftIndex].isPendingApproval) {
                showPendingDraftIcon = true;
                showDraftIcon = false;
              }
              editDocLangList.push(
                docByLangList[draftIndex]
              );
            }

          }
          else {
            editDocLangList.push({
              approvalRequestedByGpn: null,
              approvalRequestedDateTime: null,
              approvalRequestedFromEmail: null,
              approvalRequestedFromGpn: null,
              authorizationEndDateTime: null,
              authorizationEndedByGpn: null,
              authorizedByGpn: null,
              authorizedDateTime: null,
              createdBy: null,
              createdByGpn: null,
              createdDate: null,
              currentAuthorized: false,
              currentDraft: true,
              topicCardId: this.gridVersionList[0].topicCardId,
              tcversionId: 0,
              topicCardDate: null,
              description: null,
              tctitle: null,
              topicCardCategory:this.gridVersionList[0]?.topicCardCategory,
              topicCardCategoryId : this.gridVersionList[0]?.topicCardCategoryId,
              topicCardType: this.gridVersionList[0]?.topicCardType,
              topicCardTypeId: this.gridVersionList[0]?.topicCardTypeId,
              externalViews: null,
              iconRef:this.gridVersionList[0]?.iconRef,
              icon:this.gridVersionList[0]?.icon,
              isPendingApproval: false,
              languageId: engLang.languageId,
              languageName: engLang.languageName,
              modifiedBy: null,
              modifiedDate: null,
              postedDate: null,
              status: null,
              statusId: 1,
              statusName: 'Draft'
            })
          }

          //pending check for authorized doc

          this.editDocVersionList.push(
            {
              languageId: engLang.languageId,
              languageName: engLang.languageName,
              languageDocList: editDocLangList,
              showDraftButton: showDraftButton,
              showDraftIcon: showDraftIcon,
              showPendingDraftIcon: showPendingDraftIcon
            }
          )

          //reset indices
          editDocLangList = [];
          draftIndex = -1;
          nonDraftIndex = -1;
          showDraftButton = false;
          showDraftIcon = false;
          showPendingDraftIcon = false;

        });
      }
      resolve(1);
    })
      .catch(error => {
        console.log(error);
      });
  }

  viewFileVersion(fileNode:any) {
    this.selectedNode=fileNode;
    this.showFileVersionGrid = true;
    if (fileNode?.topicCardId) {
      this.manageDocService.getDocVersionByDocId(fileNode).subscribe(res => {
        if (res?.data) {
          //success
          this.docVersionList = res.data['topicCardVersionList'];
          this.showDocVersionTypeId = res.data['topicCardTypeId'];
          this.showDocVersionCategoryId = res.data['topicCardCategoryId'];
          this.formatVersionList();
        } else {
          //display error
          this.messageService.add({
            summary: this.labelReplacer('ErrorUnabletogettopicCardversion'),
            detail: res.message,
            sticky: false,
            severity: 'error'
          });
        }

      });
    }
    else {

      this.messageService.add({
        summary: this.labelReplacer('ErrorUnabletogettopicCardversion'),
        detail: '',
        sticky: false,
        severity: 'error'
      });
    }


  }

  getDocumentsHistory(fileNode) {
    var docId = fileNode.topicCardId;
    this.manageDocService.getTopicCardVersionHistoryList(docId)
      .subscribe
      (
        (resp) => {
          this.documentVersionHistoryModel = resp;
          if(this.documentVersionHistoryModel.length>0){
            this.documentVersionHistoryModel.forEach(elements=>{
              elements.statusName= this.statusReplacer(elements.statusId);
              elements.languagePath = this.appLangList.filter(x=> x.languageName==elements.languageName)[0]?.languageFlagPath;
              elements.languageName = this.languageReplacer(elements.languageName);
              elements.createdDate = this.monthReplacer(this.datePipe.transform(elements.createdDate, 'dd MMM yyyy HH:mm:ss'));
              elements.logCreatedDate = this.monthReplacer(this.datePipe.transform(elements.logCreatedDate, 'dd MMM yyyy HH:mm:ss'));
              elements.approvalRequestedStringFormat = this.monthReplacer(this.datePipe.transform(elements.approvalRequestedDateTime, 'dd MMM yyyy HH:mm:ss'));
              elements.authorizedStringFormat = this.monthReplacer(this.datePipe.transform(elements.authorizedDateTime, 'dd MMM yyyy HH:mm:ss'));
              elements.authorizationEndStringFormat = this.monthReplacer(this.datePipe.transform(elements.AuthorizationEndDateTime, 'dd MMM yyyy HH:mm:ss'));
              elements.postedDateStringFormat = this.monthReplacer(this.datePipe.transform(elements.postedDate, 'dd MMM yyyy HH:mm:ss'));
            });
          }
        }
      );
  }

  getTopicCardType() {
    return new Promise((resolve, reject) => {
      this.manageDocService.getTopicCardType().subscribe(res => {
        if (res) {
          //success
          this.docTypeList = res.data;
          this.docTypeList.forEach(element => {
            element.topicCardTypeDescription=this.activeReplacer(element.topicCardTypeDescription);
          });
        } else {
          //display error
        }
        resolve(1);
      });
    });

  }

  formatVersionList() {
    if (this.docVersionList.length > 0) {
      this.docVersionList.forEach(docVersion => {
        docVersion.languageName = this.languageReplacer(this.appLangList.filter(x => Number(x.languageId) === Number(docVersion.languageId))[0]?.languageName); 
        docVersion.languagePath = this.appLangList.filter(x=> Number(x.languageId)==Number(docVersion.languageId))[0]?.languageFlagPath;
        docVersion.statusName = this.statusReplacer(docVersion.statusId);
        docVersion.topicCardType = this.docTypeList.filter(x => Number(x.topicCardTypeId) === Number(this.showDocVersionTypeId))[0]?.topicCardTypeDescription;
        docVersion.topicCardCategory = this.docCategoryList.filter(x => Number(x.topicCardCategoryId) === Number(this.showDocVersionCategoryId))[0]?.topicCardCategoryDescription;
        docVersion.topicCardTypeId = this.showDocVersionTypeId;
        docVersion.topicCardCategoryId = this.showDocVersionCategoryId;
        docVersion.topicCardDate =  this.datePipe.transform(docVersion.topicCardDate, "dd MMM yyyy");
        docVersion.topicCardDateStr = this.monthReplacer(this.datePipe.transform(docVersion.topicCardDate, "dd MMM yyyy"));
        docVersion.authorizedDateTime = this.monthReplacer(this.datePipe.transform(docVersion.authorizedDateTime, "dd MMM yyyy"));
        docVersion.isPendingApproval = false;
      });

      if (this.docVersionList.some(x => Number(x.statusId) === 2 ||
        Number(x.statusId) === 4 || Number(x.statusId === 7))) {
        this.isApproveDisabled = false;
        this.isUnapproved = false;
      }
      else {
        this.isApproveDisabled = true;
        this.isUnapproved = true;
      }

      this.getGridVersionList();

    }
  }

  getGridVersionList() {
    let versionLangList, unauthorizedList: any[] = [];
    let draftIndex, authorizedIndex, unauthorizedIndex = -1;
    this.gridVersionList = [];
    const isVersionAuthorized = (x) => (!x.currentDraft && x.currentAuthorized);
    const isVersionDraft = (x) => (x.currentDraft && !x.currentAuthorized);
    const isDraftAuthPending = (x) => (!x.currentAuthorized && x.currentDraft
      && x.approvalRequestedByGpn != null && x.approvalRequestedFromGpn != null
      && x.authorizedByGpn === null && x.authorizedDateTime === null);

    this.engagementDetail.engLanguage.forEach(engLang => {

      versionLangList = this.docVersionList.filter(x => Number(x.languageId) === Number(engLang.languageId));

      if (versionLangList && versionLangList.length > 0) {

        draftIndex = versionLangList.findIndex(isVersionDraft);
        if (draftIndex > -1) {
          if (isDraftAuthPending(versionLangList[draftIndex])) {
            versionLangList[draftIndex].isPendingApproval = true;
          }
          this.gridVersionList.push(versionLangList[draftIndex]);
        }

        authorizedIndex = versionLangList.findIndex(isVersionAuthorized);

        if (authorizedIndex > -1) {
          this.gridVersionList.push(versionLangList[authorizedIndex]);
        }
        else {
          if (versionLangList.some(x => !x.currentAuthorized && !x.currentDraft)) {
            unauthorizedList = versionLangList?.filter(x => !x.currentAuthorized && !x.currentDraft).sort(this.date_sort_desc);
            if (unauthorizedList && unauthorizedList.length > 0) {
              this.gridVersionList.push(unauthorizedList[0]);
            }
          }

        }

      }
    });

  }



  date_sort_desc = function (a, b) {
    // This is a comparison function that will result in dates being sorted in
    // DESCENDING order.
    a = new Date(a.authorizationEndDateTime);
    b = new Date(b.authorizationEndDateTime);
    return a > b ? -1 : a < b ? 1 : 0;
  };



  onAddPanelHide() {
    this.showSideBar = false;
    this.uploadNewDoc.forEach(childRef => childRef.resetForm());
    this.addTabIndex = 0;
  }

  onEditPanelHide() {
    this.showEditSideBar = false;
    this.editTabIndex = 0;
  }


  getDocLogs() {
    this.showHistory = true;
    this.getDocumentsHistory(this.selectedNode);

  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    });
  }


  exportExcel() {
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.getDocuments());
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "documentVersionHistoryLogs");
    });
  }

  public selectionItemForFilter(e) {
    const colsTempor = e.value;
    colsTempor.sort(function (a, b) {
      return a.index - b.index;
    });
    this.colmns = [];
    this.colmns = colsTempor;
    if (e.value.length > 23) {
      e.value.pop();
    }
  }

  getDocuments() {
    let lstofdocument = [];
    for (let documents of this.documentVersionHistoryModel) {

      documents.docId = documents.topicCardId;
      lstofdocument.push(documents);
    }
    return lstofdocument;
  }

  deleteFileVersion(file) {
    const initialState = {
      paramList: {
        displayMessage: this.labelReplacer('lblDeleteDraftModal'),
        showFootNote: false,
        footNote: ''
      }
    };

    this.bsModalRef = this.modalService.show(ModalContentComponent, { initialState });
    this.bsModalRef.content.event.subscribe(res => {
      if (res.data) {

    this.spinner.show();
      //delete file from json
        //update in table and blob
        this.manageDocService.deleteDocVersion(file).subscribe(res => {
          if (res.status === 0) {
            //success
            this.saveMsg = this.labelReplacer('Draftdeletedsuccessfully');

          } else {
            //display error
            this.messageService.add({
              summary: this.labelReplacer('ErrorUnabletodelete'),
              detail: res.message,
              sticky: false,
              severity: 'error'
            });

          }

          this.refreshDocTree().then(res => {
            if (this.docVersionList?.length > 1) {
              this.viewFileVersion(file);
            }
            else {
              this.showFileVersionGrid = false;
              //this.docVersionList = [];
            }
          });

          this.spinner.hide();

        });
      }

        else {
          //do nothing
        }
      });
  }


  getDeleteFile(file): TreeNode {

    let node: TreeNode = {};
    this.selectedNode?.parent?.children?.forEach(childNode => {
      if (Number(childNode?.data[0]?.docId) === Number(file.docId)
        && Number(childNode?.data[0]?.docVersionId) === Number(file.docVersionId)) {
        node = childNode;
      }
    });

    return node;
  }

  unapproveDocument(e) {
    this.spinner.show();
    if (e.checked) {
      let documentToUnapprove = this.selectedNode;
      if (documentToUnapprove) {
        this.manageDocService.unapproveDocument(documentToUnapprove).subscribe(res => {
          if (res.status === 0) {
            //success
            this.saveMsg = this.labelReplacer('TopicCardunapprovedsuccessfully');

            // this.messageService.add({
            //   summary: 'Success',
            //   detail: 'Document unapproved successfully',
            //   sticky: false,
            //   severity: 'success'
            // });
          } else {
            //display error
            this.messageService.add({
              summary: this.labelReplacer('ErrorUnabletounapprovedocument'),
              detail: res.message,
              sticky: false,
              severity: 'error'
            });
          }

          this.refreshDocTree().then(res =>
            this.viewFileVersion(this.selectedNode));
          this.spinner.hide();

        });
      }
      else {
        this.spinner.hide();

      }
    }
  }

  refreshDocTree() {
    return new Promise((resolve, reject) => {
     this.preProcessTree()
      resolve(1);
    })
  }

  addTopicCard() {
  this.showSideBar = true;
  }

  getSavedVersion(emitSaveVersion) {
    this.spinner.show();

    let updateNode: TreeNode = {};
    this.showEditSideBar=false;
    let savedVersionData = emitSaveVersion.versionData;
    if (emitSaveVersion.isNewVersion) {
    }

    //auto save tree with new file added
    if (emitSaveVersion?.saveType?.toLowerCase() === 'save') {
      this.saveMsg = this.labelReplacer('TopicCardversionsavedsuccessfully');

    }
    else if (emitSaveVersion?.saveType?.toLowerCase() === 'other') {
      this.saveMsg = this.labelReplacer('TopicCardversionsentforapprovalsuccessfully');

    }
    else if (emitSaveVersion?.saveType?.toLowerCase() === 'self') {
      this.saveMsg = this.labelReplacer('TopicCardversionapprovedsuccessfully');
    }

    this.refreshDocTree()
    .then((res) => {
      return new Promise((resolve, reject) => {
        this.getTopicCards();
        this.viewFileVersion(this.selectedNode);
        this.showEditSideBar = false;
          this.messageService.add({
            summary: this.labelReplacer('msgTypeSuccess'),
            detail: this.saveMsg,
            sticky: false,
            severity: 'success'
          });
        resolve(1);
      })
        .then(res => this.spinner.hide())
        .catch(error => {
          console.log(error);
          this.spinner.hide();
        })
    })
    .catch((error) => {
      console.log(error);
      this.spinner.hide();
    });

    this.spinner.hide();

  }

  onTabChange(event, tabControl) {
    var selectedIndex = event.index;
    const initialState = {
      paramList: {
        displayMessage: this.labelReplacer('Areyousureyouwanttonavigateawayfromthecurrentscreen'),
        showFootNote: true,
        footNote: this.labelReplacer('Pleaseensureyoudonothaveanyunsavedchanges')
      }
    };

    if (tabControl.toLowerCase() === 'add') {
      let addChild = this.uploadNewDoc['_results'][this.addTabIndex];
      if (addChild?.documentForm.dirty) {
        this.bsModalRef = this.modalService.show(ModalContentComponent, { initialState });
        this.bsModalRef.content.event.subscribe(res => {
          if (res.data) {
            this.addTabIndex = selectedIndex;
          }
          else {
            this.ctrlAddTab.forEach((element, index) => {
              if (index === this.addTabIndex) {
                element['selected'] = true;
              }
              else {
                element['selected'] = false;
              }
            });
          }
        });
      }
      else {
        this.addTabIndex = selectedIndex;
      }
    }
    else if (tabControl.toLowerCase() === 'edit') {
      let editChild = this.editDoc['_results'][this.editTabIndex];
      if (editChild?.documentForm?.dirty) {
        this.bsModalRef = this.modalService.show(ModalContentComponent, { initialState });
        this.bsModalRef.content.event.subscribe(res => {
          if (res.data) {
            this.editTabIndex = selectedIndex;
          }
          else {
            this.ctrlEditTab.forEach((element, index) => {
              if (index === this.editTabIndex) {
                element['selected'] = true;
              }
              else {
                element['selected'] = false;
              }
            });
          }
        });
      }
      else {
        this.editTabIndex = selectedIndex;
      }
    }

  }

  getTabIcon(lang): string {
    let piClass = '';
    if (lang) {
      if (lang.showDraftIcon) {

        piClass = 'pi pi-user-edit';
      }
      else if (lang.showPendingDraftIcon) {
        piClass = 'pi pi-exclamation-circle';

      }
    }
    return piClass;
  }



  sortNode(node: TreeNode) {

    if (!('sortTypeId' in node?.data[0])) {
      node.data[0]['sortTypeId'] = '1';
    }

    if (node?.data[0]?.sortTypeId.toString() === '1') {
      node.draggable = false;
      node.droppable = false;

      if (node.children) {
        node?.children?.sort((a, b) => a.label?.localeCompare(b.label));
        node?.children.forEach(childNode => {
          childNode.draggable = false;
          childNode.droppable = false;
        });
      }
    }
    else if (node?.data[0]?.sortTypeId.toString() === '2') {
      node.draggable = false;
      node.droppable = false;

      if (node.children) {
        node?.children?.sort(this.folder_date_sort_desc);
        node?.children.forEach(childNode => {
          childNode.draggable = false;
          childNode.droppable = false;
        });
      }
    }
    else if (node?.data[0]?.sortTypeId.toString() === '3') {
      node.draggable = false;
      node.droppable = true;
      if (node.children) {
        node?.children.forEach(childNode => {
          if (childNode.type.toLowerCase() === 'file') {
            childNode.draggable = true;
            childNode.droppable = false;
          }
          else {
            childNode.draggable = false;
            childNode.droppable = false;
          }

        });
      }

    }
  }


  folder_date_sort_desc = function (a, b) {
    // This is a comparison function that will result in dates being sorted in
    // DESCENDING order.
    if (a?.type?.toLowerCase() === 'file') {
      a = a?.data[0]?.documentDate ?? new Date(a?.data[0]?.createdDTTM);
    }
    else {
      a = new Date(a?.data[0]?.createdDTTM);
    }

    if (b?.type?.toLowerCase() === 'file') {
      b = b?.data[0]?.documentDate ?? new Date(b?.data[0]?.createdDTTM);
    }
    else {
      b = new Date(b?.data[0]?.createdDTTM);
    }

    return a > b ? -1 : a < b ? 1 : 0;
  };


}
